import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Vue logo",
  src: _imports_0
}, null, -1)

import { ref, reactive, onMounted, Ref } from 'vue'
  import headerComponent from '@/components/home/headerComponent.vue';
  import footerComponent from '@/components/home/footerComponent.vue';
  import sideBar from '@/components/home/sideBar.vue';
import BuySinglePaper from "../components/buyVip/BuySinglePaper.vue";
import { useStore } from 'vuex'

import { queryExampaperList } from "@/api/index";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

  // 从vue中引入ref onMounted
  const store = useStore()
const count = ref(0);
let dialogVisible: Ref<number> = ref(0); // 是否勾选开通会员
const handleShowBuyPaper = () => {
  dialogVisible.value += 1;
};
onMounted(() => {
  queryExampaperList({
    grade: 6,
    key_word: "1",
    position_id: "200",
    subject: "2",
    page_info: {
      count: 0,
      limit: 10,
      max_page: 0,
      page: 1,
    },
  })
    .then((res) => {
      // console.log(res)
    })
    .catch((err) => {
      console.log(err);
    });
});

return (_ctx: any,_cache: any) => {
  const _component_buy_paper_success = _resolveComponent("buy-paper-success")!
  const _component_pay_status_dialog = _resolveComponent("pay-status-dialog")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BuySinglePaper, {
      showBuyPaper: _unref(dialogVisible),
      title: "详解版",
      isVip: false,
      paperUnitPrice: "90.00"
    }, null, 8, ["showBuyPaper"]),
    _createVNode(_component_buy_paper_success),
    _createVNode(_component_pay_status_dialog),
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(count.value) + " ", 1),
    _createVNode(_component_el_button, {
      text: "",
      onClick: handleShowBuyPaper
    }, {
      default: _withCtx(() => [
        _createTextVNode("打开单卷购买弹窗")
      ]),
      _: 1
    })
  ]))
}
}

})